{
	"title": "Služba není k dispozici (500)",
	"description": "Zkuste obnovit tuto stránku nebo zkontrolujte připojení k internetu. Pokud tato chyba přetrvává, nahlaste ji prosím jako chybu, abychom mohli podniknout kroky.",
	"primaryButtonTitle": "Obnovit stránku",
	"secondaryButtonTitle": "Zkopírujte protokol chyb",
	"errorLogCopiedMessage": "Protokol chyb byl zkopírován",
	"traceparentLabel": "Traceparent"
}
